/**
 * @author: yanhoup
 * @description: 全局数据
 */
import { getLocale } from '@/locales/locale';
import { request } from 'ice';

interface IState {
  name: string;
  department: string;
  avatar: string;
  userid: number | null;
  warehouse: string;
  menu: string;
  warehouseName: any;
}

export default {
  state: {
    name: 'default',
    department: '',
    avatar: '',
    userid: null,
    menu: 'index',
    warehouse: '',
    warehouseList: [], // list
    warehouseName: '', // 当前选中的warehouseName
  },

  effects: (dispatch) => ({
    async fetchUserProfile() {
      const res = await request('/api/profile');
      if (res.status === 'SUCCESS') {
        dispatch.user.update(res.data);
      }
    },
    async fetchWarehouse() {
      const data = getLocale() === 'zh-CN' ? 'CN' : 'EN';
      const res = await request(`giws-basic/rpc/warehouse/getWarehouseByRegionalAndUser?lan=${data}`);

      const wareMenuList: [] = [];
      const dealWareMenu = (list) => {
        const item = {
          ...list,
          label: list?.name,
          value: list?.code,
        };
        wareMenuList.push(item);
        if (list.warehouses) {
          list.warehouses?.forEach((_e) => dealWareMenu(_e));
        }
      };

      if (res) {
        const warehouseList = [...res];
        warehouseList?.forEach((e) => dealWareMenu(e));
        localStorage.removeItem('wareMenuList');
        localStorage.setItem('wareMenuList', JSON.stringify(wareMenuList));
        if (res.length) {
          localStorage.removeItem('wareMenu');
          localStorage.setItem('wareMenu', JSON.stringify(res[0]?.warehouses));
        }
      }
    },
  }),

  reducers: {
    update(prevState: IState, payload: object) {
      return { ...prevState, ...payload };
    },
    updateMenu(prevState: IState, payload: object) {
      return { ...prevState, ...payload };
    },
  },
};
